<template>
  <div>
    <modal
      class="device-embedded-information-bach-edit-modal"
      width="460px"
      :backdrop="false"
      :value="showModal"
      effect="fade"
      @closed="closed"
    >
      <div slot="modal-header" class="modal-header">
        <!--
          Sample for question 11
          Header start here.
            -->
        <h4 class="modal-title">
            <strong>本当に登録してよろしいでしょうか。</strong>
        </h4>
        <!--
          Sample for question 11
          Header ends here.
            -->
      </div>
      <div
        class="modal-body device-embedded-information-bach-edit-modal-body"
        style="height: 100px;padding: 0px 15px; overflow-x: auto;"
      >
      <!--
        Sample for question 11
        Body start here.
        Control the body height in the above style;
         -->
        <!-- <div class="form-group ">
          <label class="control-label">Field name</label>
          <input
            ref="local_value"
            style="margin-top:10px;"
            type="text"
            class="form-control"
            v-on:input="updateValue($event.target.value)"
            id="local_value"
            name="local_value"
            v-bind:value="localValue"
            placeholder
            />
        </div> -->
      <!--
        Sample for question 11
        Body ends here.
         -->
      </div>
      <div slot="modal-footer" class="modal-footer" style="background:white">
        <!--
          Sample for question 11
          Footer start here.
          -->
        <button type="button" class="btn btn-default" @click="closed('no')">キャンセル</button>
        <button type="button" class="btn btn-primary" @click="closed('yes')">完了</button>
        <!--
          Sample for question 11
          Footer ends here.
          -->
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from "vue";
import { bus } from "@/libs/bus";
import { utils } from "@/libs/utils";
var vm = this;

import modal from "./local-modal";

Vue.component("modal", modal);
import _ from "lodash";
import debug from "debug";
var debug_input_manual = debug("esma:input-modal");

export default {
  data() {
    return {
      show_modal: false,
      title_label: "",
      callback: null,
      local_value: ""
    };
  },
  computed: {
    localValue: {
      get() {
        return this.local_value;
      },
      set(v) {
        console.log("showModalWindow Set localValue", v);
        this.local_value = v;
      }
    },
    showModal() {
      return this.show_modal;
    }
  },
  methods: {
    updateValue(val) {
      this.localValue = val;
      this.$emit("inputed", this.localValue);
    },
    onShow() {},
    showModalWindow(data) {
      /** 
       * Sample for question 11
       * 
       * This method will be called when the modal be mounted.
       */
      this.onShow();
      this.localValue = data.initial_value || "";
      this.show_modal = true;
    },
    closed(mode) {
      if (mode == "yes") {
        this.$emit("save", this.localValue);
      }
      this.$emit("closed", this.localValue);
      this.show_modal = false;
    }
  },
  props: {
    tag: { type: String, default: "showDeviceEmbeddedInformationAddCheck" }
  },
  mounted() {
    debug_input_manual("On mounted");
    bus.$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy() {
    bus.$off(this.$props.tag);
  }
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// device-embedded-information-add_check.vue?0749b403